export default {
  postExchangeCode(params) {
    return this.http(
      'ExerciseCheck',
      'post',
      '/api/v1/exchange_codes',
      params
    );
  },

  getRankList(params) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/weight_ranks/top_three?group_id=${params}`
    );
  },

  // 获取message消息
  getMsgList() {
    return this.http('ExerciseCheck', 'get', '/api/v1/messages.json');
  },

  // 获取历史消息列表
  getHistoryMsg(id) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/messages/${id}/history`
    );
  },

  // 提交留言
  postMsg(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/messages', params);
  },

  getUserNiceMes() {
    return this.http('ExerciseCheck', 'get', '/api/v1/user');
  },

  getSignUpStatus(id) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/collections/${id}/user_collections`
    );
  },

  createOrder(id, params) {
    return this.http(
      'ExerciseCheck',
      'post',
      `/api/v1/collections/${id}/user_collections`,
      params
    );
  },

  getDetails(id, options) {
    return this.http(
      'ExerciseCheck',
      'get',
      `/api/v1/collections/${id}`,
      options
    );
  },

  postUserMes(id, options) {
    return this.http(
      'ExerciseCheck',
      'post',
      `/api/v1/collections/${id}/user_collections/evaluate`,
      options
    );
  }
};
